(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name commons.service:ToolBarService
   *
   * @description
   *
   */
  angular
    .module('commons')
    .service('ToolBarService', ToolBarService);

  function ToolBarService(EventManagerService, CommonMasterData) {
    var self = this;
      self.model = {
          viewModeCreatePairing:null,
          buttonConfig:{}
      };

      self.getToolBarSelectionByKey = function(key){
          return self.model[key];
      };

      self.setToolBarSelectionWithKey = function(key, value){
          return self.model[key] = value;
      };

      self.setViewModeCreatePairing = function(mode){
          self.model.viewModeCreatePairing = mode;
      };

      self.setButtonConfigsToView = function(view, config){
          self.model.buttonConfig[view] = config;
          EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.CONFIG_CHANGED);
      };

      self.getButtonConfigsByView = function(view){
          return self.model.buttonConfig[view];
      };

    self.getAeroOpsEnableParam = function(){
      CommonMasterData.getAeroOpsEnableParam(
        function (aeroOpsEnableParam) {
          if(angular.equals(aeroOpsEnableParam.paramValue,"Y")){
            return true;
          }else{
            return false;
          }

        },
        function () {
          console.log('AeroOps Enable Param retrieval error');
        }
      );
    }
  }
}());
